import React, { FC, ReactElement, MouseEvent } from 'react'
import { onKeyboardClick } from '@/utils/a11y/keyboard-click'

const CopyIcon: FC<{
	className?: string
	width?: number
	height?: number
	onClick?: (evt: MouseEvent) => void
}> = (props): ReactElement => {
	return (
		<svg
			onClick={props.onClick}
			viewBox="0 0 16 15"
			fill="none"
			className={props.className}
			width={props.width}
			height={props.height}
			role={props.onClick ? "button" : undefined}
			tabIndex={props.onClick ? 0 : undefined}
			onKeyDown={onKeyboardClick(props.onClick)}
		>
			<path d="M0 7.5C0 7.72 0.09 7.91 0.27 8.08L5.99 13.79C6.16 13.95 6.34 14.03 6.55 14.03C6.97 14.03 7.31 13.72 7.31 13.29C7.31 13.08 7.23 12.88 7.09 12.75L5.16 10.78L2.26 8.14L4.34 8.27H15.24C15.69 8.27 16 7.95 16 7.5C16 7.05 15.69 6.73 15.24 6.73H4.34L2.27 6.86L5.16 4.22L7.09 2.25C7.23 2.11 7.31 1.92 7.31 1.71C7.31 1.28 6.97 0.97 6.55 0.97C6.34 0.97 6.16 1.04 5.97 1.23L0.27 6.92C0.09 7.09 0 7.28 0 7.5Z" />
		</svg>
	)
}

export default CopyIcon
